<template>
  <ul class="signing-step">
    <li v-for="(item, index) in steps" :key="index" :class="{ 'signing-step-cur': active === index + 1 }">
      <span class="sign-circle">
        <i :class="{ 'sign-icon-hook': index + 1 < active }">{{ index + 2 > active ? item.number : '' }} </i></span
      >{{ item.title }}<span class="signing-step-arrow sign-icon-right"></span>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'FddSteps',
    props: {
      active: {
        type: Number,
        default: 1
      },
      steps: Array
    }
  }
</script>
